module.exports = __webpack_public_path__ + "5dd51e8dfd51cdb03fcc3eba44c2f82a.svg";